import { formatPlaybackFrameTimestamp } from "./radarPlaybackRange.js";

export function formatRadarTimestamp(timestampIso, { playback = false } = {}) {
  if (playback) {
    return formatPlaybackFrameTimestamp(timestampIso);
  }

  if (!timestampIso) {
    return "—";
  }

  const date = new Date(timestampIso);
  if (Number.isNaN(date.getTime())) {
    return "—";
  }

  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
